import { getUrlApi } from "./Api.js";
const axios = require('axios');
// const glpiUrl = process.env.REACT_APP_GLPI_URL;
// const glpiApiURL = glpiUrl + "apirest.php/";
// const tokenUserGLPI = process.env.REACT_APP_TOKEN_USER_GLPI;
// const tokenAppGLPI = process.env.REACT_APP_TOKEN_APP_GLPI;
// const idProjetoGLPI = process.env.REACT_APP_ENTIDADDE_PROJETO_GLPI;

let glpiCriteriaId;
getUrlApi("REACT_APP_CRITERIA_FIELD_ID").then((data) => {
  glpiCriteriaId = data;
});

let glpiUrl;
getUrlApi("REACT_APP_GLPI_URL").then((data) => {
  glpiUrl = data;
});

let glpiApiURL = glpiUrl + "apirest.php/";

let tokenUserGLPI;
getUrlApi("REACT_APP_TOKEN_USER_GLPI").then((data) => {
  tokenUserGLPI = data;
});

let tokenAppGLPI;
getUrlApi("REACT_APP_TOKEN_APP_GLPI").then((data) => {
  tokenAppGLPI = data;
});

let idProjetoGLPI;
getUrlApi("REACT_APP_ENTIDADDE_PROJETO_GLPI").then((data) => {
  idProjetoGLPI = data;
});

const init = async () => {
  await getUrlApi("REACT_APP_GLPI_URL").then((data) => {
    glpiUrl = data;
  });
  await getUrlApi("REACT_APP_TOKEN_USER_GLPI").then((data) => {
    tokenUserGLPI = data;
  });
  await getUrlApi("REACT_APP_TOKEN_APP_GLPI").then((data) => {
    tokenAppGLPI = data;
  });
  await getUrlApi("REACT_APP_ENTIDADDE_PROJETO_GLPI").then((data) => {
    idProjetoGLPI = data;
  });
  await getUrlApi("REACT_APP_CRITERIA_FIELD_ID").then((data) => {
    glpiCriteriaId = data;
  });
  glpiApiURL = glpiUrl + "apirest.php/";
}

const getToken = async () => {
  await init();
  let headers = {
    'headers': {
      Authorization: 'user_token ' + tokenUserGLPI,
      'App-Token': tokenAppGLPI
    }
  };
  return await axios.get(glpiApiURL + 'initSession', headers)
}

const initSession = async () => {
  return JSON.parse(localStorage.getItem('session'));
}

export const guardarSessionGlpi = async () => {
  //let sessionAtual = await initSession();
  //if(sessionAtual){
  //  killSession(sessionAtual.data.session_token);
  //}
  let session = await getToken();
  console.log("Sessão do GLPI obtida")
  localStorage.setItem('session', JSON.stringify(session));
}

const getRequester = async (session, idTicket) => {
  let headers = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI
    }
  };
  return await axios.get(glpiApiURL + 'Ticket/' + idTicket + '/Ticket_User', headers)
}

const getUser = async (session, email) => {
  let headers = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI
    }
  };
  return await axios.get(glpiApiURL + 'User?searchText[name]=' + email, headers)
}

export const getFollowup = async (idTicket) => {
  let resposta = await initSession();
  let session = resposta.data.session_token;
  let headers = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI
    }
  };
  return axios.get(glpiApiURL + 'Ticket/' + idTicket + '/ITILFollowup', headers);
}

const removeRequerente = async (session, idTicket) => {
  let requerente = await getRequester(session, idTicket);
  let headers = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI
    }
  };
  return await axios.delete(glpiApiURL + 'Ticket/' + idTicket + '/Ticket_User/' + requerente.data[0].id, headers)
}

const addRequester = async (session, idTicket, email) => {
  let headers = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI
    }
  };
  let user = []
  try {
    user = await getUser(session, email);
  } catch (err) {
    console.log(err)
  }
  let newRequester = {
    "input": {
      "tickets_id": idTicket,
      "users_id": 0,
      "type": 1,
      "use_notification": 1,
      "alternative_email": email
    }
  }
  if (user.data.length > 0) {
    newRequester = {
      "input": {
        "tickets_id": idTicket,
        "users_id": user.data[0].id,
        "type": 1,
        "use_notification": 1,
      }
    }
  }
  return await axios.post(glpiApiURL + 'Ticket_User', newRequester, headers);
}

const postCriarTicket = async (session, ticket) => {
  let headers = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI
    }
  };
  return await axios.post(glpiApiURL + 'Ticket', ticket, headers);
}

export const uploadFile = async (file, idEntidade) => {
  let formData = new FormData();
  let resposta = await initSession();
  let session = resposta.data.session_token;
  let headers = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI,
      'Content-Type': 'multipart/form-data'
    },
  };
  formData.append("uploadManifest", "{\"input\": {\"name\": \"Uploaded document\",\"_filename\":\"" + file.name + "\",\"entities_id\":" + idEntidade + "}}");
  formData.append("filename[0]", file, "slogo-azul.png");
  return await axios.post(glpiApiURL + 'Document', formData, headers);
}

export const deleteFile = async (id) => {
  let resposta = await initSession();
  let session = resposta.data.session_token;
  let headers = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI,
    },
  };
  return await axios.delete(glpiApiURL + 'Document/' + id, headers);
}

export const associarFiles = async (id,arquivos) => {
  let resposta = await initSession();
  let session = resposta.data.session_token;
  let headers = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI,
    },
  };
  let inputBody = [];
  arquivos.map((fil) => {
    let obj = {
      "documents_id": fil.id,
      "items_id": id,
      "itemtype": "Ticket"
    };
    inputBody.push(obj);
    return fil;
  });
  let body = {
    "input": inputBody
  };
  return await axios.post(glpiApiURL + 'Ticket/' + id + '/Document_Item',body,headers);
}

export const criarTicket = async (descricao, titulo, email, idEntidade = 86, idCategoria) => {
  try {
    await guardarSessionGlpi();
  } catch (error) {
    console.log(error);
  }
  let resposta = await initSession();
  let session = resposta.data.session_token;
  let newTicket = {
    "input": {
      "entities_id": idEntidade,
      "name": titulo,
      "content": descricao,
      "requesttypes_id": 8,
      "itilcategories_id": idCategoria,
    }
  };
  let ticket = null;
  try {
    ticket = await postCriarTicket(session, newTicket);
    removeRequerente(session, ticket.data.id);
    addRequester(session, ticket.data.id, email);
  } catch (e) {
    let message = e.message;
    if (message === "Network Error") {
      throw new Error("Network Error");
    }
  }
  return ticket.data.id;
}

export const getItilCategories = async (idPai = null) => {
  await init();
  let resposta = await initSession();
  let session = resposta.data.session_token;
  let config = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI,
    },
    cache: true
  };

  let categorias = await axios.get(
    glpiApiURL +
    'search/ITILCategory?' +
    'criteria[0][field]=' + glpiCriteriaId +
    '&criteria[0][value]=' + idPai +
    `&criteria[0][searchtype]=${idPai ? `equals` : 'contains'}`,
    config
  )
  return categorias;
}

export const getItilEntity = async (idPai = null) => {
  let resposta = await initSession();
  let session = resposta.data.session_token;
  let config = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI,
    },
    cache: true
  };

  let categorias = await axios.get(
    glpiApiURL +
    'search/Entity?' +
    'criteria[0][field]=' + glpiCriteriaId +
    '&criteria[0][value]=' + idPai +
    '&criteria[0][searchtype]=equals',
    config
  )
  return categorias;
}

export const getCountTicket = async (idEntidade) => {
  let resposta = await initSession();
  let session = resposta.data.session_token;
  let config = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI,
    },
    cache: true
  };

  let tickets = await axios.get(
    glpiApiURL +
    'search/Ticket?' +
    'criteria[0][field]=80' +
    '&criteria[0][value]=' + idEntidade +
    '&criteria[0][searchtype]=equals&range=0-1',
    config
  )
  return tickets.data.totalcount;
}

export const getCountTicketBrasil = async () => {
  let resposta = await initSession();
  let session = resposta.data.session_token;
  let config = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI,
    },
    cache: true
  };

  let tickets = await axios.get(
    glpiApiURL +
    'search/Ticket?' +
    'criteria[0][field]=80' +
    '&criteria[0][value]=' + idProjetoGLPI +
    '&criteria[0][searchtype]=under&range=0-1',
    config
  )
  return tickets.data.totalcount;
}

export const getCountAtendente = async (cpfAtendente) => {
  let resposta = await initSession();
  let session = resposta.data.session_token;
  let config = {
    'headers': {
      'Session-Token': session,
      'App-Token': tokenAppGLPI,
    },
    cache: true
  };

  let tickets = await axios.get(
    glpiApiURL +
    'search/Ticket?' +
    'criteria[0][field]=1' +
    '&criteria[0][value]=Atendente:%20' + cpfAtendente +
    '&criteria[0][searchtype]=contains&range=0-1',
    config
  )
  return tickets.data.totalcount;
}
